import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { toastError } from "../../Components/Toasts/Toast";
import { set, useForm } from "react-hook-form";
import { getAllAssembles } from "../../Services/AssemblyServices";
import { getSegmentAll } from "../../Services/SegmentService";
import {
  getProduct,
  saveDraft,
  updateProduct,
  updateV2,
} from "../../Services/ProductService";
import { getLanguages } from "../../Services/LanguageService";
import { getExportFile, getImportFile } from "../../Services/FileService";
import { getProductsAll } from "../../Services/ProductService";
import { getSeupplier } from "../../Services/SAPService";
import Common from "../../Constants/Common";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ProductDetailPage from "./ProductDetailPage";
import Overlay from "../../Components/Overlay/Overlay";
import ModalVideoDesc from "../../Components/Product/Modal/ModalVideoDesc";
import ModalFormVideo from "../../Components/Product/Modal/ModalFormVideo";
import ModalImageDesc from "../../Components/Product/Modal/ModalImageDesc";
import ModalFormFeature from "../../Components/Product/Modal/ModalFormFeature";
import ProductImage from "../../Components/Product/FileHandler/ProductImage";
import ProductVideo from "../../Components/Product/FileHandler/ProductVideo";
import {
  capitalizeFirstLetter,
  cleanCurrency,
  handlerFormError,
} from "../../Utils/Utils";
import {
  getAppList,
  getImageFunc,
  getVideoFunc,
} from "../../Services/AppService";

const { $ } = window;
const modalId = "#product-create-modal";
const modalId2 = "#product-create-video";
const modalId3 = "#product-create-video-desc";
const modalId10 = "#product-create-feature-score";
const wrapStyle = {
  width: 130,
  height: 100,
  borderRadius: 4,
  marginRight: 16,
  marginBottom: 16,
  position: "relative",
  border: "solid 1px #ccc",
  borderRadius: 6,
};
let processingId = -1;

//update gadanta
const ProductDetailFormPage = () => {
  const REVISE = 2;
  const APPROVE = 1;
  const REJECT = 3;
  let { userInfo } = useSelector((state) => state.auth);
  const { country_code, item_code } = useParams();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id_segment: "1",
      id_category: "",
      id_sub_category: "",
      id_sub_sub_category: 0,
      id_series: 0,
      prefix: "",
      id_brand: "",
      prefix: "",
      color: "",
      model_code: "",
      item_name: "",
      item_code_original: "",
      group_code: "",
      country_code: "",
      certificate: "",
      electrical_rating: "",
      assembly: "",
      part_change_sequence: "",
      part_change_location: "",
      unit: "",
      series: "",
      height: 0,
      width: 0,
      length: 0,
      depth: 0,
      weight: 0,
      volume: 0,
      outer_height: 0,
      outer_width: 0,
      outer_length: 0,
      outer_depth: 0,
      outer_weight: 0,
      cut_out_height: 0,
      cut_out_width: 0,
      cut_out_length: 0,
      cut_out_depth: 0,
      cut_out_height_topmount: 0,
      cut_out_width_topmount: 0,
      cut_out_length_topmount: 0,
      cut_out_height_undermount: 0,
      cut_out_width_undermount: 0,
      cut_out_length_undermount: 0,
      weight_type: "",
      scale: "",
      launch_date: "",
      cardcode: "",
      barcode_sni: "",
      barcode_qr: "",
      is_active: true,
      is_publish_web: false,
      is_manage_serial: false,
      numRows: 1,
      numRowsUps: 1,
      product_class: "",
    },
  });
  const [is_draft_saved, setIsDraftSaved] = useState(false);
  const [detail_change, setDetailChange] = useState(false);

  const [state, setState] = useState({
    product: null,
    countryChange: country_code,
    manualBooksDelete: [],
    products: [],
    suppliers: [],
    selectedItemCode: "",
    selectedSupplierCode: "",
    segments: [],
    categories: [],
    subcategories: [],
    subsubcategories: [],
    pseries: [],
    id_sub_sub_category: 0,
    id_series: 0,
    image_change: false,
    colors: [],
    countries: [],
    certs: [],
    eratings: [],
    assembles: [],
    pcls: [],
    brands: [],
    subprefixs: [],
    skuHeaders: [],
    sku: [],
    activeIndex: -1,
    firstPrefix: "",
    secondPrefix: "",
    firstColor: "",
    secondColor: "",
    firstCountry: "",
    secondCountry: "",
    cert: "",
    erating: "",
    assembly: "",
    partSequence: "",
    pcl: "",
    files: [],
    manualBooks: [],
    filesDescs: [],
    filesBase64: [],
    videoDescs: [],
    fileSelected: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    videoSelected: "",
    brandPrefix: "",
    media_types: [],
    video_types: [],
    content_types: [],
    is_active: true,
    is_publish_web: false,
    is_manage_serial: false,
    languages: [],
    selectedLang: {
      language_code: "",
      language_name: "",
    },
    productDetails: [],
    productDetail: {
      language_code: "",
      language_name: "",
      title: "",
      header_description: "",
      description: "",
      feature: "",
      including: "",
      tagline: "",
      price: "",
      manual_book: "",
      is_preorder: 0,
      is_rental: 0,
      is_active: true,
      is_me_by_modena: 0,
      sku_me_by_modena: "",
      sticker_price: 0,
      seo_title: "",
      seo_description: "",
      url_ar: "",
    },
    productHighlights: [],
    productHighlight: [],
    deletedHighlight: [],
    deletedEcom: [],
    filesNew: [],
    filesDescsNew: [],
    fileSelectedNew: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    productUpss: [],
    productUps: [
      // {
      //   "id": null,
      //   "name": "",
      //   "media_code": "",
      //   "media_type": [],
      //   "media_desc": "",
      //   "content_type": [],
      //   "file_path": "",
      //   "tags": []
      // },
    ],
    filesUps: [],
    filesDescsUpss: [],
    filesDescsUps: [],
    fileSelectedUps: {
      fileNameUps: "",
      media_desc: "",
      language_code: "",
      line_num: "",
      media_types: [],
      content_types: [],
    },
    productEcom: [],
    deleteEcom: [],
    feature_type: [],
    reqFeature: [],
    totScoreFeature: 0,
    processing: false,
    videoUrl: "",
    videoLang: "",
    numRows: 1,
    numRowsUps: 1,
    show: false,
    activeTab: "tab1",
    sub_sub_category: {},
    deletedFile: [],
    deletedDetail: [],
    deletedFileNew: [],
    deletedFileUps: [],
    deletedHighlight: [],
    deletedUps: [],
    deletedUpsTag: [],
    deletedVideo: [],
    deletedEcom: [],
  });

  const onAddFileDescModal = (type, position) => {
    const index =
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.indexOf(type)
        : filesDescs[fileSelected.fileName].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.splice(index, 1)
        : filesDescs[fileSelected.fileName].content_types.splice(index, 1);
    } else {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.push(type)
        : filesDescs[fileSelected.fileName].content_types.push(type);
    }

    setState({ ...state, filesDescs });
  };
  console.log("userinfo", userInfo);
  const onApprovalAction = (selected_action) => {
    const formData = new FormData();
    setState({ ...state, processing: true });
    const data = {};
    Swal.fire({
      title:
        "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
      input: "textarea", // Specify the input type as "textarea"
      inputPlaceholder: "Approval remark here",
      allowOutsideClick: false,
      inputAttributes: {
        rows: 4, // Number of rows for the textarea
        required: true,
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
    }).then((result) => {
      if (result.isConfirmed) {
        // The user confirmed, and you can access the textarea value
        const textarea_value = result.value;
        data["selected_action"] = selected_action;
        //master approval data
        data[`additionalDetails[incident_id]`] = product.incident_id;
        data[`additionalDetails[incident_status]`] = product.incident_status;
        data[`additionalDetails[next_step_nik]`] = product.next_step_nik;
        data[`additionalDetails[next_step_name]`] = product.next_step_name;
        data[`additionalDetails[next_step_task_id]`] = product.next_step_task_id;
        data[`additionalDetails[item_code]`] = product.item_code;
        data[`additionalDetails[country_code]`] = product.country_code;
        //detail approval data
        data[`additionalDetails[incident_id_detail]`] = product.incident_id_detail;
        data[`additionalDetails[incident_status_detail]`] = product.incident_status_detail;
        data[`additionalDetails[next_step_nik_detail]`] = product.next_step_nik_detail;
        data[`additionalDetails[next_step_name_detail]`] = product.next_step_name_detail;
        data[`additionalDetails[next_step_task_id_detail]`] = product.next_step_task_id_detail;

        data[`additionalDetails[image_change]`] = product.image_change
          ? product.image_change
          : image_change;
        data[`additionalDetails[video_change]`] = product.video_change
          ? product.video_change
          : video_change;
        data[`additionalDetails[highlight_change]`] = product.highlight_change
          ? product.highlight_change
          : highlight_change;
        data[`additionalDetails[usp_change]`] = product.usp_change
          ? product.usp_change
          : usp_change;
        data[`additionalDetails[ecom_change]`] = product.ecom_change
          ? product.ecom_change
          : ecom_change;
        data[`additionalDetails[item_name]`] = product.item_name;
        data[`additionalDetails[model_code]`] = product.model_code;
        data[`additionalDetails[incident_status_detail]`] = product.incident_status_detail;
        data[`additionalDetails[country_name]`] = product.country_name;
        data[`additionalDetails[brand_name]`] = product.brand_name;
        data[`additionalDetails[series_name]`] = product.series_name;
        data[`additionalDetails[segment_name]`] = product.segment_name;
        data[`additionalDetails[category_name]`] = product.category_name;
        data[`additionalDetails[sub_category_name]`] = product.sub_category_name;
        data[`additionalDetails[sub_sub_category_name]`] = product.sub_sub_category_name;
        data[`additionalDetails[next_step_nik_detail]`] = product.next_step_nik_detail;
        const formData = new FormData();
        if (nullProductDataCheck(data) == true) {
          setState({ ...state, processing: false });
          return;
        }
        putInProductDetails(data, productDetails);
        putInFeatureType(data, feature_type);
        putInProductHighlights(data, productHighlights);
        putInProductUps(data, productUps);
        putInManualBooks(data, manualBooks);
        if (
          productEcom &&
          productEcom.length > 0 &&
          putInProductEcom(data, productEcom) == false
        ) {
          toastError("Please fill all ecommerce data before submit!");
          setState({ ...state, processing: false });
          return;
        }

        if (putInVideoDescriptions(data, videoDescs) > 0) {
          toastError("Please complete data for product video!");
          setState({ ...state, processing: false });
          return;
        }

        putInProductImages(data, files);
        putInProductHighlightImages(data, filesNew);
        putInProductUpsImages(data, filesUps);

        if (putInImageDescriptions(data, filesDescs) > 0) {
          toastError("Please complete data for product image!");
          setState({ ...state, processing: false });
          return;
        }

        if (putInHighlightsFileDescriptions(data, filesDescsNew, filesNew) > 0) {
          setState({ ...state, processing: false });
          toastError("Please complete data for product highlight image!");
          return;
        }

        for (var key in data) {
          formData.append(key, data[key]);
        }

        if (putInUspFileDescriptions(formData, filesDescsUps) > 0) {
          setState({ ...state, processing: false });
          toastError("Please complete data for product usp image!");
          return;
        }
        formData.append("detail_approval_remark", textarea_value);
        updateV2(item_code, formData)
          .then((res) => {
            if (res.data.status == 200) {
              setState({ ...state, processing: false });
              setIsDraftSaved(true);
              Swal.fire({
                icon: "success",
                title: "Save data success",
                text: "Data has been saved!",
              }).then((r) => navigate("/product"));
            } else {
              setState({ ...state, processing: false });
              Swal.fire({
                icon: "error",
                title: "Save data failed",
                text: "There's an issue with the system. Please contact IT Support for assistance!",
              });
            }
          })
          .catch((err) => {
            setState({ ...state, processing: false });
            Swal.fire({
              icon: "error",
              title: "Save data failed",
              text: "There's an issue with the system. Please contact IT Support for assistance!",
            });
          });
      } else {
        setState({ ...state, processing: false });
      }
    });
  };

  const onDescChange = (e) => {
    filesDescs[fileSelected.fileName].media_desc = e.target.value;
    const _fileSelected = { ...fileSelected, media_desc: e.target.value };
    setState({ ...state, filesDescs, fileSelected: _fileSelected });
  };

  useEffect(() => {
    const reqSegment = getSegmentAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqLang = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqExportFile = getExportFile("product_master").then(
      (res) => res.data
    );
    const reqImport = getImportFile("product_master").then((res) => res.data);
    const reqAssemble = getAllAssembles({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqProduct = getProduct(item_code, "detail").then((res) => res.data);
    const reqVideoType = getVideoFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqMediaType = getImageFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqContentType = getAppList({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    Promise.all([
      reqSegment,
      reqLang,
      reqExportFile,
      reqImport,
      reqAssemble,
      reqProduct,
      reqVideoType,
      reqMediaType,
      reqContentType,
    ]).then((results) => {
      const [
        _segment,
        _langs,
        _fileExport,
        _fileImport,
        _assembles,
        _product,
        _video_types,
        _media_types,
        _content_types,
      ] = results;
      if (_product.mode && _product.mode == "draft") {
        setIsDraftSaved(true);
        setTimeout(() => {
          setState({
            ...state,
            mode: _product.mode ? " (" + _product.mode.toUpperCase() + ") " : "",
            product: _product.additionalDetails,
            languages: _langs,
            productDetails: _product.productDetails,
            productHighlights: _product.productHighlights,
            video_types: _video_types,
            media_types: _media_types,
            filesNew: _product.filesNew,
            content_types: _content_types,
            productUps: _product.productUps
              ? _product.productUps
              : [
                {
                  name: "",
                  media_code: "",
                  media_type: "",
                  media_desc: "",
                  content_type: "",
                  file_path: "",
                  tags: [],
                },
              ],
            productEcom: _product.productEcom
              ? _product.productEcom
              : [{ id_store: "", url: "", price: "", line_num: 0 }],
            filesDescs: _product.filesDescs,
            files: _product.files ? _product.files : [],
            filesUps: _product.filesUps ? _product.filesUps : [],
            filesDescsNew: _product.filesDescsNew,
            deletedUps: _product?.deletedUps ? _product?.deletedUps : [],
            fileSelectedNew: _product.fileSelectedNew,
            filesDescsUps: _product.filesDescsUps,
            filesDescsUpss: _product.filesDescsUps,
            videoDescs: _product.videoDescs,
            productDetail:
              _product.productDetails.length > 0
                ? _product.productDetails[0]
                : {
                  language_code: "",
                  language_name: "",
                  title: "",
                  header_description: "",
                  description: "",
                  feature: "",
                  including: "",
                  tagline: "",
                  price: 0,
                  manual_book: null,
                  is_preorder: 0,
                  is_rental: 0,
                  is_active: true,
                  is_publish_web: false,
                  is_me_by_modena: 0,
                  sku_me_by_modena: "",
                  sticker_price: 0,
                  seo_title: "",
                  seo_description: "",
                  url_ar: "",
                },
          });
        }, 100);
      } else if (
        (!_product?.product?.is_creation_approved ||
          _product?.product?.is_creation_approved == "false") &&
        _product?.product?.next_step_nik != userInfo?.nik
      ) {
        Swal.fire({
          title: "Not Allowed!",
          text: "This product is not approved yet. Please wait for approval of the product first!",
          icon: "error",
        }).then((r) => navigate("/product"));
      } else {
        const fExport = _fileExport.status != 404 ? _fileExport : null;
        const fImport = _fileImport.status != 404 ? _fileImport : [];
        _product.filesDescs = !Array.isArray(_product.filesDescs)
          ? [_product.filesDescs]
          : _product.filesDescs;
        let j = 0;
        for (const key in _product.filesDescs[0]) {
          if (_product.files[j]) {
            _product.files[j]["fileIndex"] = key;
          }
          filesDescs[key] = {
            fileIndex: key,
            fileName: _product.filesDescs[0][key].fileName,
            media_desc: _product.filesDescs[0][key].media_desc,
            media_types: _product.filesDescs[0][key].media_types,
            content_types: _product.filesDescs[0][key].content_types,
            skip: _product.filesDescs[0][key].skip,
          };
          j++;
        }
        _product.filesDescsNew = !Array.isArray(_product.filesDescsNew)
          ? [_product.filesDescsNew]
          : _product.filesDescsNew;
        if (_product.filesDescsNew && _product.filesDescsNew.length > 0) {
          let i = 0;
          for (const key in _product.filesDescsNew[0]) {
            if (_product.filesNew[i]) {
              _product.filesNew[i]["fileIndex"] = key;
            }
            let namaFile = _product.filesDescsNew[0][key].file_name
              ? _product.filesDescsNew[0][key].file_name
              : _product.filesDescsNew[0][key].fileName;
            filesDescsNew[key] = {
              fileIndex: key,
              fileName: namaFile,
              file_name: namaFile,
              media_desc: _product.filesDescsNew[0][key].media_desc
                ? _product.filesDescsNew[0][key].media_desc
                : _product.filesDescsNew[0][key][0].media_desc,
              media_types: _product.filesDescsNew[0][key].media_types
                ? _product.filesDescsNew[0][key].media_types
                : _product.filesDescsNew[0][key][0].media_type,
              content_types: _product.filesDescsNew[0][key].content_types
                ? _product.filesDescsNew[0][key].content_types
                : _product.filesDescsNew[0][key][0].content_type,
              skip: _product.filesDescsNew[0][key].skip,
            };
            i++;
          }
        }

        // for (const key in _product.filesDescsUps[0]) {
        //     filesDescsUps[key] = {
        //         fileNameUps: _product.filesDescsUps[0][key].fileName,
        //         media_desc: _product.filesDescsUps[0][key].media_desc,
        //         media_types: _product.filesDescsUps[0][key].media_types,
        //         language_code: _product.filesDescsUps[0][key].language_code,
        //         line_num: _product.filesDescsUps[0][key].line_num,
        //         content_types: _product.filesDescsUps[0][key].content_types,
        //         skip: _product.filesDescsUps[0][key].skip,
        //     }
        // }
        /*_product.videoDescs = !Array.isArray(_product.videoDescs)
        ? [[_product.videoDescs]]
        : _product.videoDescs;*/
        for (const key in _product.videoDescs[0]) {
          videoDescs[key] = {
            filePath: _product.videoDescs[0][key].filePath,
            fileName: _product.videoDescs[0][key].fileName,
            id: _product.videoDescs[0][key].id,
            media_types: _product.videoDescs[0][key].media_types,
            media_desc: _product.videoDescs[0][key].media_desc,
            content_types: _product.videoDescs[0][key].content_types,
            language_code: _product.videoDescs[0][key].language_code,
            language_name: _product.videoDescs[0][key].language_name,
          };
        }
        const filesUps = [];
        if (!_product.filesUps) {
          _product.productUps.forEach((item) => filesUps.push(item));
        }

        setTimeout(() => {
          setState({
            ...state,
            languages: _langs,
            fileExport: fExport,
            files: fImport,
            segments: _segment,
            assembles: _assembles,
            product: _product.product,
            productDetails: _product.productDetails,
            productHighlights: _product.productHighlights,
            video_types: _video_types,
            media_types: _media_types,
            filesNew: _product.filesNew,
            content_types: _content_types,
            filesUps: filesUps,
            productUps: _product.productUps
              ? _product.productUps
              : [
                {
                  name: "",
                  media_code: "",
                  media_type: "",
                  media_desc: "",
                  content_type: "",
                  file_path: "",
                  tags: [],
                },
              ],
            productEcom: _product.productEcom
              ? _product.productEcom
              : [{ id_store: "", url: "", price: "", line_num: 0 }],
            filesDescs: filesDescs,
            files: _product.files,
            filesDescsNew: filesDescsNew,
            deletedUps: _product?.deletedUps ? _product?.deletedUps : [],
            fileSelectedNew: _product.fileSelectedNew,
            filesDescsUps: filesDescsUps,
            filesDescsUpss: filesDescsUps,
            videoDescs: videoDescs,
            productDetail:
              _product.productDetails.length > 0
                ? _product.productDetails[0]
                : {
                  language_code: "",
                  language_name: "",
                  title: "",
                  header_description: "",
                  description: "",
                  feature: "",
                  including: "",
                  tagline: "",
                  price: 0,
                  manual_book: null,
                  is_preorder: 0,
                  is_rental: 0,
                  is_active: true,
                  is_publish_web: false,
                  is_me_by_modena: 0,
                  sku_me_by_modena: "",
                  sticker_price: 0,
                  seo_title: "",
                  seo_description: "",
                  url_ar: "",
                },
          });
        }, 100);
      }
    });
  }, []);

  const onBack = () => {
    if (item_code) {
      navigate("/product-details");
    } else {
      navigate(-1);
    }
  };


  const onCopyItemCode = (item_code) => {
    navigate(`/product/copy/${item_code}`);
  };

  const onSetItemCode = (e) => {
    setState({ ...state, selectedItemCode: e.target.value });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onFormVideo = () => {
    $(modalId2).modal("show");
  };

  const onFileChange = (e) => {
    const _files = [...files, ...e.target.files];
    // if (e.target.name == "product-image") setImageChange(true);
    setState({ ...state, files: _files, image_change: true });
  };

  const onRemoveFile = (file, i) => {
    let filesColl = undefined;
    if (file.url) {
      delete filesDescs[file.file_name || file.fileName];
      deletedFile.push(file.fileName || file.file_name || file.name);
    }
    files.splice(i, 1);
    setState({ ...state, files, deletedFile, filesDescs });
  };

  const onRemoveVideo = (i) => {
    if (videoDescs[i].id) {
      deletedVideo.push(videoDescs[i].id);
      videoDescs.splice(i, 1);
      setState({ ...state, videoDescs, deletedVideo });
    } else {
      videoDescs.splice(i, 1);
      setState({ ...state, videoDescs });
    }
  };
  const onAddFileDesc = (file) => {
    setState({ ...state, fileSelected: {} });
    const fileName = (file.fileName || file.name || file.file_name)
      .split(" ")
      .join("");
    if (filesDescs[fileName]) {
      setState({ ...state, fileSelected: filesDescs[fileName], filesDescs });
    } else {
      filesDescs[fileName] = {
        fileIndex: fileName,
        fileName,
        media_desc: "",
        media_types: [],
        content_types: [],
      };
      setState({ ...state, filesDescs, fileSelected: filesDescs[fileName] });
    }

    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const onAddVideoDesc = (video) => {
    const videoIndex = videoDescs.findIndex(
      (e) => e.fileName == video.fileName
    );
    setState({ ...state, videoSelected: videoIndex });
    setTimeout(() => {
      $(modalId3).modal("show");
    }, 150);
  };

  const genModelCode = (setFirstColor, setSecondColor) => {
    const modelCode = `${firstPrefix}${secondPrefix} ${sku[3] || ""}${sku[4] || ""
      }${sku[5] || ""}${sku[6] || ""} ${sku[7] || ""}${sku[8] || ""}${setFirstColor || ""
      }${setSecondColor || ""}`;
    setValue("model_code", modelCode);
  };

  const onSubmit = () => {
    const data = {};
    setState({ ...state, processing: true });
    data["update_mode"] = "details";
    data[`additionalDetails[item_name]`] = product.item_name;
    data[`additionalDetails[item_code]`] = product.item_code;
    data[`additionalDetails[country_code]`] = product.country_code;
    data[`additionalDetails[model_code]`] = product.model_code;
    data[`additionalDetails[incident_status_detail]`] =
      product.incident_status_detail;
    data[`additionalDetails[country_name]`] = product.country_name;
    data[`additionalDetails[brand_name]`] = product.brand_name;
    data[`additionalDetails[series_name]`] = product.series_name;
    data[`additionalDetails[segment_name]`] = product.segment_name;
    data[`additionalDetails[category_name]`] = product.category_name;
    data[`additionalDetails[image_change]`] = product.image_change;
    data[`additionalDetails[video_change]`] = product.video_change;

    data[`additionalDetails[highlight_change]`] = product.highlight_change;
    data[`additionalDetails[usp_change]`] = product.usp_change;
    data[`additionalDetails[ecom_change]`] = product.ecom_change;
    data[`additionalDetails[sub_category_name]`] = product.sub_category_name;
    data[`additionalDetails[sub_sub_category_name]`] =
      product.sub_sub_category_name;
    data[`additionalDetails[next_step_nik_detail]`] =
      product.next_step_nik_detail;
    const formData = new FormData();
    if (nullProductDataCheck(data) == true) {
      setState({ ...state, processing: false });
      return;
    }
    putInProductDetails(data, productDetails, "final save");
    putInFeatureType(data, feature_type);
    putInProductHighlights(data, productHighlights);
    putInProductUps(data, productUps);
    putInManualBooks(data, manualBooks);

    if (putInProductEcom(data, productEcom) == false) {
      toastError("Please fill all ecommerce data before submit!");
      setState({ ...state, processing: false });
      return;
    }

    if (putInVideoDescriptions(data, videoDescs) > 0) {
      toastError("Please complete data for product video!");
      setState({ ...state, processing: false });
      return;
    }

    putInProductImages(data, files);
    putInProductHighlightImages(data, filesNew);
    putInProductUpsImages(data, filesUps);

    if (putInImageDescriptions(data, filesDescs) > 0) {
      toastError("Please complete data for product image!");
      setState({ ...state, processing: false });
      return;
    }

    if (putInHighlightsFileDescriptions(data, filesDescsNew, filesNew) > 0) {
      toastError("Please complete data for product highlight image!");
      setState({ ...state, processing: false });
      return;
    }

    //console.log(data);
    //return;

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (putInUspFileDescriptions(formData, filesDescsUps) > 0) {
      toastError("Please complete data for product usp image!");
      setState({ ...state, processing: false });
      return;
    }

    //return;

    if (deletedFile.length > 0 || deletedVideo.length > 0) {
      Swal.fire({
        icon: "question",
        title: "Are you sure?",
        text: `There is ${deletedFile.length} image & ${deletedVideo.length} video will be delete, you can't restore it after press OK button!`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          Swal.fire({
            title:
              "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
            input: "textarea", // Specify the input type as "textarea"
            inputPlaceholder: "Approval remark here",
            allowOutsideClick: false,
            inputAttributes: {
              rows: 4, // Number of rows for the textarea
              required: true,
            },
            showCancelButton: true,
            confirmButtonText: "Submit",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
          }).then((result) => {
            if (result.isConfirmed) {
              const textarea_value = result.value;
              formData.append("detail_approval_remark", textarea_value);
              // The user confirmed, and you can access the textarea value
              updateV2(item_code, formData)
                .then((res) => {
                  if (res.data.status == 200) {
                    setState({ ...state, processing: false });
                    setIsDraftSaved(true);
                    Swal.fire({
                      icon: "success",
                      title: "Save data success",
                      text: "Data has been saved!",
                    }).then((r) => navigate(0));
                  } else {
                    setState({ ...state, processing: false });
                    Swal.fire({
                      icon: "error",
                      title: "Save data failed",
                      text: "There's an issue with the system. Please contact IT Support for assistance!",
                    });
                  }
                })
                .catch((err) => {
                  setState({ ...state, processing: false });
                  Swal.fire({
                    icon: "error",
                    title: "Save data failed",
                    text: "There's an issue with the system. Please contact IT Support for assistance!",
                  });
                });
            }
          });
        }
      });
    } else {
      Swal.fire({
        title:
          "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
        input: "textarea", // Specify the input type as "textarea"
        inputPlaceholder: "Approval remark here",
        allowOutsideClick: false,
        inputAttributes: {
          rows: 4, // Number of rows for the textarea
          required: true,
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
      }).then((result) => {
        if (result.isConfirmed) {
          // The user confirmed, and you can access the textarea value
          const textarea_value = result.value;
          formData.append("detail_approval_remark", textarea_value);
          updateV2(item_code, formData)
            .then((res) => {
              if (res.data.status == 200) {
                setState({ ...state, processing: false });
                setIsDraftSaved(true);
                Swal.fire({
                  icon: "success",
                  title: "Save data success",
                  text: "Data has been saved!",
                }).then((r) => navigate(0));
              } else {
                setState({ ...state, processing: false });
                Swal.fire({
                  icon: "error",
                  title: "Save data failed",
                  text: "There's an issue with the system. Please contact IT Support for assistance!",
                });
              }
            })
            .catch((err) => {
              setState({ ...state, processing: false });
              Swal.fire({
                icon: "error",
                title: "Save data failed",
                text: "There's an issue with the system. Please contact IT Support for assistance!",
              });
            });
        }
      });
    }
  };

  const onSaveDraft = () => onSubmitDraft();

  const nullProductDataCheck = (data) => {
    let xx = 0;
    if (!productDetails || (productDetails && productDetails.length <= 0)) {
      toastError("Please save product detail before submit!");
      return true;
    }
    for (let pd in productDetails) {
      if (
        productDetails[xx].title == "" ||
        productDetails[xx].description == "" ||
        productDetails[xx].header_description == "" ||
        productDetails[xx].tagline == "" ||
        productDetails[xx].id_color == "" ||
        productDetails[xx].id_tag == ""
      ) {
        toastError("Please save product detail before submit!");
        return true;
      }
      xx++;
    }
    for (const key in productHighlights) {
      if (
        productHighlights[key].title == "" ||
        productHighlights[key].description == ""
      ) {
        toastError(
          "Please fill title and description product highlight before submit!"
        );
        return true;
      }
    }

    for (let yt in productUps) {
      let dataDescUps = productUps[yt];
      let dataTags = productUps[yt].tags;

      if (productUps[yt].media_desc == "") {
        toastError("Please fill all product usp highlight before submit!");
        return true;
      }

      if (dataDescUps.file_path == "" && dataTags.length > 0) {
        toastError(
          "Please upload the image for product usp highlight before submit!"
        );
        return true;
      }

      if (dataDescUps.file_path != "") {
        if (dataTags) {
          for (let ee in dataTags) {
            if (dataTags[ee].title == "" || dataTags[ee].description == "") {
              toastError(
                "Please fill title and description product usp highlight before submit!"
              );
              return true;
            }
          }
        } else {
          toastError(
            "Please fill title and description product usp highlight before submit!"
          );
          return true;
        }
      }
    }

    let i = 0;
    if (productEcom && productEcom.length > 0) {
      for (let eco of productEcom) {
        let dataEco = eco;
        if (
          eco.id_store != "" &&
          eco.url != "" &&
          eco.price != "" &&
          eco.id_store != null &&
          eco.url != null &&
          eco.price != null
        ) {
          for (let ec in dataEco) {
            if (ec == "id" && eco[ec])
              data[`productEcom[${i}]["id"]`] = eco[ec];
            else data[`productEcom[${i}][ec]`] = eco[ec];
          }
        } else {
          toastError("Please fill all ecommerce data before submit!");
          return true;
        }
        i++;
      }
    }
  };

  const putInVideoDescriptions = (submission, videoDescs) => {
    let c_video_errors = 0;
    /*let tempVideo = [];
    for (let v in videoDescs) {
      for (let i in deletedVideo) {
        if (deletedVideo[i] == videoDescs[v].id) {
          continue;
        } else {
          tempVideo.push(videoDescs[v]);
        }
      }
    }*/
    //videoDescs = tempVideo;
    let jj = 0;
    for (let v of videoDescs) {
      submission[`videoDescs[${jj}][file_path]`] = v.filePath;
      submission[`videoDescs[${jj}][file_name]`] = v.fileName;
      submission[`videoDescs[${jj}][language_code]`] = v.language_code;
      submission[`videoDescs[${jj}][language_name]`] = v.language_name;
      submission[`videoDescs[${jj}][media_type]`] = v.media_types;
      submission[`videoDescs[${jj}][content_type]`] = v.content_types;

      if (v.content_types == 0) {
        c_video_errors++;
      }
      jj++;
    }
    return c_video_errors;
  };

  const putInProductDetails = (submission, productDetails, mode = null) => {
    let i = 0;
    for (let pd in productDetails) {
      submission[`productDetails[${i}][id]`] = productDetails[pd].id;
      submission[`productDetails[${i}][item_code]`] = item_code;
      submission[`productDetails[${i}][country_code]`] = country_code;
      submission[`productDetails[${i}][language_code]`] = productDetails[pd].language_code;
      submission[`productDetails[${i}][language_name]`] = productDetails[pd].language_name;
      submission[`productDetails[${i}][title]`] = productDetails[pd].title;
      submission[`productDetails[${i}][header_description]`] = productDetails[pd].header_description;
      submission[`productDetails[${i}][description]`] = productDetails[pd].description;
      submission[`productDetails[${i}][feature]`] = productDetails[pd].feature;
      submission[`productDetails[${i}][including]`] = productDetails[pd].including;
      submission[`productDetails[${i}][tagline]`] = productDetails[pd].tagline;
      submission[`productDetails[${i}][price]`] = productDetails[pd].price || 0;
      if (mode == "final save")
        submission[`productDetails[${i}][price]`] = cleanCurrency(productDetails[pd].price) || 0;
      submission[`productDetails[${i}][id_color]`] = productDetails[pd].id_color;
      submission[`productDetails[${i}][id_tag]`] = productDetails[pd].id_tag;
      submission[`productDetails[${i}][manual_book]`] = productDetails[pd].manual_book;
      submission[`productDetails[${i}][is_preorder]`] = productDetails[pd].is_preorder == "0" ? 0 : 1;
      submission[`productDetails[${i}][is_rental]`] = productDetails[pd].is_rental == "0" ? 0 : 1;
      submission[`productDetails[${i}][is_me_by_modena]`] = productDetails[pd].is_me_by_modena == "0" ? 0 : 1;
      submission[`productDetails[${i}][sku_me_by_modena]`] = productDetails[pd].sku_me_by_modena;
      submission[`productDetails[${i}][sticker_price]`] = productDetails[pd].sticker_price;
      submission[`productDetails[${i}][is_active]`] = productDetails[pd].is_active == "0" ? 0 : 1;
      submission[`productDetails[${i}][seo_title]`] = productDetails[pd].seo_title;
      submission[`productDetails[${i}][seo_description]`] = productDetails[pd].seo_description;
      submission[`productDetails[${i}][url_ar]`] = productDetails[pd].url_ar;
      submission[`productDetails[${i}][product_display_name]`] = productDetails[pd].product_display_name;
      i++;
    }
  };

  const putInFeatureType = (submission, feature_type) => {
    for (let ft in feature_type) {
      let dataFeature = feature_type[ft];
      if (feature_type[ft].score > 0) {
        for (let fD in dataFeature) {
          submission[`feature_type[${ft}][${fD}]`] = feature_type[ft][fD];
        }
      } else {
        toastError("Please fill all score feature type!");
        return;
      }
    }
  };

  const putInProductHighlights = (submission, productHighlights) => {
    const tempHighlights = [];

    console.log(deletedHighlight);
    productHighlights.forEach((highlight, index) => {
      for (let zz in deletedHighlight) {
        if (deletedHighlight[zz].language_code == highlight.language_code) {
          continue;
        } else {
          tempHighlights.push(highlight);
        }
      }
    });
    if (tempHighlights.length != 0) productHighlights = tempHighlights;
    for (let pdh in productHighlights) {
      let dataHighlight = productHighlights[pdh];
      if (
        productHighlights[pdh].title != "" &&
        productHighlights[pdh].description != ""
      ) {
        for (let pdhD in dataHighlight) {
          submission[`productHighlights[${pdh}][${pdhD}]`] =
            productHighlights[pdh][pdhD];
        }
      }
    }
  };

  const putInProductUps = (submission, productUps) => {
    const tempUps = [];
    let jj = 0;
    deletedUps.forEach((ups, index) => {
      submission[`deletedUps[${jj}][file_name]`] = ups["file_name"];
      submission[`deletedUps[${jj}][item_code]`] = ups["item_code"];
      jj++;
    });
    productUps.forEach((ups, index) => {
      for (let zz in deletedUps) {
        if (deletedUps[zz].language_code == ups.language_code) {
          continue;
        } else {
          tempUps.push(ups);
        }
      }
    });
    for (let ii in productUps) {
      let dataDescUps = productUps[ii];
      let dataTags = productUps[ii].tags;
      let tempTags = [];
      if (
        productUps[ii].file_path != "" &&
        productUps[ii].file_path != undefined
      ) {
        for (let index in dataDescUps) {
          if (index != "tags") {
            submission[`productUps[${ii}][${index}]`] = dataDescUps[index];
          }
        }

        for (let ee in dataTags) {
          for (let zz in deletedUpsTag) {
            if (deletedUpsTag[zz].language_code == dataTags[ee].language_code) {
              continue;
            } else {
              tempTags.push(dataTags[ee]);
            }
          }
        }
        //dataTags = tempTags;
        for (let ee in dataTags) {
          for (let tag in dataTags[ee]) {
            submission[`productUps[${ii}][tags][${ee}][${tag}]`] =
              dataTags[ee][tag];
          }
        }
      }
    }
  };

  const putInManualBooks = (submission, manualBooks) => {
    for (let i in manualBooks) {
      submission[`manual_books[${i}]`] = manualBooks[i][0];
    }
  };

  const putInImageDescriptions = (submission, filesDescs) => {
    let m_image_errors = 0;
    let c_image_errors = 0;
    for (let n in files) {
      let namaFile = (files[n].fileName ?? files[n].name).split(" ").join("");
      if (namaFile != undefined || namaFile != "") {
        if (filesDescs[namaFile] && filesDescs[namaFile].fileName != "") {
          if (filesDescs[namaFile].media_types.length == 0) {
            m_image_errors++;
          }

          if (filesDescs[namaFile].content_types == 0) {
            c_image_errors++;
          }
        } else {
          m_image_errors++;
          c_image_errors++;
        }
      }
    }
    Object.keys(filesDescs).forEach((f) => {
      submission[`filesDescs[${f}][fileName]`] = filesDescs[f].fileName;
      submission[`filesDescs[${f}][media_desc]`] = filesDescs[f].media_desc;
      submission[`filesDescs[${f}][media_type]`] = filesDescs[f].media_types;
      submission[`filesDescs[${f}][content_type]`] = filesDescs[f].content_types;

      if (filesDescs[f].media_types.length == 0) {
        m_image_errors++;
      }

      if (filesDescs[f].content_types == 0) {
        c_image_errors++;
      }

      if (filesDescs[f].media_desc == "") {
        c_image_errors++;
      }
    });
    return m_image_errors + c_image_errors;
  };

  const putInHighlightsFileDescriptions = (
    submission,
    filesDescsNew,
    filesNew
  ) => {
    let m_image_errors = 0;
    let c_image_errors = 0;
    if (filesNew && filesNew.length > 0) {
      if (Object.keys(filesDescsNew).length > 0) {
        for (let n in filesDescsNew) {
          submission[`filesDescsNew[${n}][fileName]`] = filesDescsNew[n].fileName;
          submission[`filesDescsNew[${n}][media_desc]`] =
            filesDescsNew[n].media_desc;
          submission[`filesDescsNew[${n}][media_type]`] =
            filesDescsNew[n].media_types;
          submission[`filesDescsNew[${n}][content_type]`] =
            filesDescsNew[n].content_types;
          if (filesDescsNew[n].fileName != "" && filesDescsNew[n].file_name != undefined) {
            if (filesDescsNew[n].media_types.length == 0) {
              m_image_errors++;
            }

            if (filesDescsNew[n].content_types == 0) {
              c_image_errors++;
            }
          }
        }
      } else {
        m_image_errors++;
        c_image_errors++;
      }

      return m_image_errors + c_image_errors;
    }
  };

  const putInUspFileDescriptions = (submission, filesDescsUps) => {
    let m_image_errors = 0;
    let c_image_errors = 0;
    for (let oo in filesDescsUps) {
      submission.append(
        `filesDescsUps[${oo}][fileName]`,
        filesDescsUps[oo].fileName || filesDescsUps[oo].file_name || filesDescsUps[oo].name
      );
      submission.append(
        `filesDescsUps[${oo}][media_desc]`,
        filesDescsUps[oo].media_desc
      );
      submission.append(
        `filesDescsUps[${oo}][media_type]`,
        filesDescsUps[oo].media_types || filesDescsUps[oo].media_type
      );
      submission.append(
        `filesDescsUps[${oo}][content_type]`,
        filesDescsUps[oo].content_types || filesDescsUps[oo].content_type
      );

      if (filesDescsUps[oo].fileName != "" || filesDescsUps[oo].file_name != "") {
        if ((filesDescsUps[oo].media_types || filesDescsUps[oo].media_type).length == 0) {
          m_image_errors++;
        }

        if ((filesDescsUps[oo].content_types || filesDescsUps[oo].content_type).length == 0) {
          c_image_errors++;
        }
      }

      // if (filesDescsUps[oo]?.value.fileName != "" || filesDescsUps[oo]?.value.file_name != "") {
      //   if ((filesDescsUps[oo].value.media_types || filesDescsUps[oo].value.media_type).length == 0) {
      //     m_image_errors++;
      //   }

      //   if ((filesDescsUps[oo]?.value.content_types || filesDescsUps[oo]?.value.content_type).length == 0) {
      //     c_image_errors++;
      //   }
      // }
    }
    return m_image_errors + c_image_errors;
  };

  const putInProductHighlightImages = (submission, filesNew) => {
    let temp_files = [];
    for (let i in filesNew) {
      for (let j in deletedFileNew) {
        if (deletedFileNew[j].file_path == filesNew[i].file_path) {
          continue;
        } else {
          temp_files.push(files[i]);
        }
      }
    }

    if (temp_files.length > 0) filesNew = temp_files;

    if (Array.isArray(filesNew) && filesNew.length > 0) {
      filesNew.forEach((file, index) => {
        submission[`imagesHighlight[${index}]`] = file;
      });
    } else {
      for (let i in filesNew) {
        submission[`imagesHighlight[${i}]`] = filesNew[i];
      }
    }
  };

  const putInProductUpsImages = (submission, filesUps) => {
    for (let j in filesUps) {
      if (filesUps[j] instanceof File) {
        submission[`imagesUsp[${j}]`] = filesUps[j];
      } else {
        submission[`imagesUsp[${j}]`] = JSON.stringify(filesUps[j]);
      }
    }
  };

  const putInProductImages = (submission, files) => {
    for (let i in files) {
      submission[`images[${i}]`] = files[i];
    }

    //nggak bisa langsung dihapus di gateway meskipun filenya tidak ada di array files. maka file yang dihapusnya dibawa ke gateway nanti di compare mana yang tidak ada di redis.
    for (let i in deletedFile) {
      submission[`deletedFile[${i}]`] = deletedFile[i];
    }
  };

  const putInProductEcom = (submission, productEcom) => {
    console.log(productEcom);
    let i = 0;
    for (let eco of productEcom) {
      let dataEco = eco;
      if (
        eco.id_store != "" &&
        eco.url != "" &&
        eco.price != "" &&
        eco.id_store != null &&
        eco.url != null &&
        eco.price != null
      ) {
        for (let ec in dataEco) {
          submission[`productEcom[${i}][${ec}]`] = eco[ec];
        }

        return true;
      } else {
        return false;
      }
      i++;
    }
  };

  const onSubmitDraft = () => {
    const data = {};
    setState({ ...state, processing: true });
    //master approval data
    data[`additionalDetails[incident_id]`] = product.incident_id;
    data[`additionalDetails[incident_status]`] = product.incident_status;
    data[`additionalDetails[next_step_nik]`] = product.next_step_nik;
    data[`additionalDetails[next_step_name]`] = product.next_step_name;
    data[`additionalDetails[next_step_task_id]`] = product.next_step_task_id;
    data[`additionalDetails[item_code]`] = product.item_code;
    data[`additionalDetails[country_code]`] = product.country_code;
    //detail approval data
    data[`additionalDetails[incident_id_detail]`] = product.incident_id_detail;
    data[`additionalDetails[incident_status_detail]`] = product.incident_status_detail;
    data[`additionalDetails[next_step_nik_detail]`] = product.next_step_nik_detail;
    data[`additionalDetails[next_step_name_detail]`] = product.next_step_name_detail;
    data[`additionalDetails[next_step_task_id_detail]`] = product.next_step_task_id_detail;

    data[`additionalDetails[image_change]`] = product.image_change
      ? product.image_change
      : image_change;
    data[`additionalDetails[video_change]`] = product.video_change
      ? product.video_change
      : video_change;
    data[`additionalDetails[highlight_change]`] = product.highlight_change
      ? product.highlight_change
      : highlight_change;
    data[`additionalDetails[usp_change]`] = product.usp_change
      ? product.usp_change
      : usp_change;
    data[`additionalDetails[ecom_change]`] = product.ecom_change
      ? product.ecom_change
      : ecom_change;
    data[`additionalDetails[item_name]`] = product.item_name;
    data[`additionalDetails[model_code]`] = product.model_code;
    data[`additionalDetails[incident_status_detail]`] = product.incident_status_detail;
    data[`additionalDetails[country_name]`] = product.country_name;
    data[`additionalDetails[brand_name]`] = product.brand_name;
    data[`additionalDetails[series_name]`] = product.series_name;
    data[`additionalDetails[segment_name]`] = product.segment_name;
    data[`additionalDetails[category_name]`] = product.category_name;
    data[`additionalDetails[sub_category_name]`] = product.sub_category_name;
    data[`additionalDetails[sub_sub_category_name]`] = product.sub_sub_category_name;
    data[`additionalDetails[next_step_nik_detail]`] = product.next_step_nik_detail;
    const formData = new FormData();
    if (nullProductDataCheck(data) == true) {
      setState({ ...state, processing: false });
      return;
    }
    putInProductDetails(data, productDetails);
    putInFeatureType(data, feature_type);
    putInProductHighlights(data, productHighlights);
    putInProductUps(data, productUps);
    putInManualBooks(data, manualBooks);
    if (
      productEcom &&
      productEcom.length > 0 &&
      putInProductEcom(data, productEcom) == false
    ) {
      toastError("Please fill all ecommerce data before submit!");
      setState({ ...state, processing: false });
      return;
    }

    if (putInVideoDescriptions(data, videoDescs) > 0) {
      toastError("Please complete data for product video!");
      setState({ ...state, processing: false });
      return;
    }

    putInProductImages(data, files);
    putInProductHighlightImages(data, filesNew);
    putInProductUpsImages(data, filesUps);

    if (putInImageDescriptions(data, filesDescs) > 0) {
      toastError("Please complete data for product image!");
      setState({ ...state, processing: false });
      return;
    }

    if (putInHighlightsFileDescriptions(data, filesDescsNew, filesNew) > 0) {
      setState({ ...state, processing: false });
      toastError("Please complete data for product highlight image!");
      return;
    }

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (putInUspFileDescriptions(formData, filesDescsUps) > 0) {
      setState({ ...state, processing: false });
      toastError("Please complete data for product usp image!");
      return;
    }

    if (deletedFile.length > 0 || deletedVideo.length > 0) {
      /*Swal.fire({
        icon: "question",
        title: "Are you sure?",
        text: `There is ${deletedFile.length} image & ${deletedVideo.length} video will be delete, you can't restore it after press OK button!`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
      }).then(({ isConfirmed }) => {*/
      //if (isConfirmed) {
      /*Swal.fire({
            title:
              "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
            input: "textarea", // Specify the input type as "textarea"
            inputPlaceholder: "Approval remark here",
            allowOutsideClick: false,
            inputAttributes: {
              rows: 4, // Number of rows for the textarea
              required: true,
            },
            showCancelButton: true,
            confirmButtonText: "Submit",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work*/
      //}).then((result) => {
      //if (result.isConfirmed) {
      // The user confirmed, and you can access the textarea value
      saveDraft(item_code, formData)
        .then((res) => {
          if (res.data.status == 200) {
            setState({ ...state, processing: false });
            setIsDraftSaved(true);
            Swal.fire({
              icon: "success",
              title: "Save data success",
              text: "Data has been saved!",
            })
              .then((r) => navigate(0));
          } else {
            setState({ ...state, processing: false });
            Swal.fire({
              icon: "error",
              title: "Save data failed",
              text: "There's an issue with the system. Please contact IT Support for assistance!",
            });
          }
        })
        .catch((err) => {
          setState({ ...state, processing: false });
          Swal.fire({
            icon: "error",
            title: "Save data failed",
            text: "There's an issue with the system. Please contact IT Support for assistance!",
          });
        });
      //}
      //});
      //}
      //});
    } else {
      /*const response = updateProduct(item_code, formData);
      startProcessing();
      response
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            Swal.fire({
              icon: "success",
              title: "Save data success",
              text: "Data has been saved!",
            }).then((r) => onBack());
          }
        })
        .catch(({ response: { data } }) => {
          handlerFormError(data);
        })
        .finally((_) => stopProcessing());*/
      /*Swal.fire({
        title:
          "Please enter a remark/message about the resolution. Also, images with no image description will not be uploaded",
        input: "textarea", // Specify the input type as "textarea"
        inputPlaceholder: "Draft remark here",
        allowOutsideClick: false,
        inputAttributes: {
          rows: 4, // Number of rows for the textarea
          required: true,
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),*/ // Prevent closing during async work
      //}).then((result) => {
      //if (result.isConfirmed) {
      // The user confirmed, and you can access the textarea value
      //const textarea_value = result.value;
      //formData.append("detail_approval_remark", textarea_value);

      saveDraft(item_code, formData)
        .then((res) => {
          if (res.data.status == 200) {
            setState({ ...state, processing: false });
            setIsDraftSaved(true);
            Swal.fire({
              icon: "success",
              title: "Save data success",
              text: "Data has been saved!",
            })
              .then((r) => navigate(0));
          } else {
            setState({ ...state, processing: false });
            Swal.fire({
              icon: "error",
              title: "Save data failed",
              text: "There's an issue with the system. Please contact IT Support for assistance!",
            });
          }
        })
        .catch((err) => {
          setState({ ...state, processing: false });
          Swal.fire({
            icon: "error",
            title: "Save data failed",
            text: "There's an issue with the system. Please contact IT Support for assistance!",
          });
        });
      //}
      //});
    }
  };

  const countDimension = (e) => {
    if (e.target.value != "" && !isNaN(e.target.value)) {
      let height =
        e.target.id == "height"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.height);
      let width =
        e.target.id == "width"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.width);
      let length = parseFloat(control._formValues.length);
      let depth = parseFloat(control._formValues.depth);

      if (e.target.id == "length" && (depth <= 0 || depth == "")) {
        length = parseFloat(e.target.value);
        setValue("length", length);
        if (length == 0) {
          setValue("outer_length", 0);
        }
      } else if (e.target.id == "length") {
        length = 0;
        setValue("length", 0);
        setValue("outer_length", 0);
      }

      if (e.target.id == "depth" && (length <= 0 || length == "")) {
        depth = parseFloat(e.target.value);
        setValue("depth", depth);
        if (depth == 0) {
          setValue("outer_depth", 0);
        }
      } else if (e.target.id == "depth") {
        depth = 0;
        setValue("depth", 0);
        setValue("outer_depth", 0);
      }

      if (e.target.id == "outer_length" && (length <= 0 || length == "")) {
        setValue("outer_length", 0);
      }

      if (e.target.id == "outer_depth" && (depth <= 0 || depth == "")) {
        setValue("outer_depth", 0);
      }

      if (height && width && length > 0) {
        setValue(
          "volume",
          ((length / 10) * (width / 10) * (height / 10)).toFixed(4)
        );
      } else if (height && width && depth > 0) {
        setValue(
          "volume",
          ((depth / 10) * (width / 10) * (depth / 10)).toFixed(4)
        );
      }
    } else {
      setValue(e.target.id, "");
    }
  };

  const {
    subcategories,
    pseries,
    subsubcategories,
    subprefixs,
    firstPrefix,
    secondPrefix,
    firstColor,
    secondColor,
    firstCountry,
    secondCountry,
    cert,
    erating,
    assembly,
    partSequence,
    pcl,
    skuHeaders,
    activeIndex,
    sku,
    colors,
    countries,
    certs,
    eratings,
    assembles,
    pcls,
    segments,
    categories,
    brands,
    filesBase64,
    files,
    brandPrefix,
    filesDescs,
    fileSelected,
    media_types,
    video_types,
    content_types,
    productDetails,
    processing,
    videoUrl,
    videoDescs,
    videoSelected,
    videoLang,
    languages,
    products,
    selectedItemCode,
    selectedSupplierCode,
    suppliers,
    countryChange,
    productDetail,
    manualBooks,
    filesNew,
    fileSelectedNew,
    filesDescsNew,
    productHighlights,
    deletedHighlight,
    productHighlight,
    filesUps,
    fileSelectedUps,
    filesDescsUps,
    filesDescsUpss,
    productUps,
    productEcom,
    deleteEcom,
    reqFeature,
    totScoreFeature,
    feature_type,
    sub_sub_category,
    product,
    deletedFile,
    deletedVideo,
    deletedFileNew,
    deletedFileUps,
    deletedUps,
    deletedEcom,
    deletedUpsTag,
    image_change
  } = state;

  useEffect(() => {
    const seriesCode = brandPrefix + firstPrefix + secondPrefix;
    setValue("series", seriesCode);
  }, [firstPrefix, secondPrefix, brandPrefix]);

  useEffect(() => {
    if (selectedItemCode != "") {
      const timeOut = setTimeout(() => {
        getProductsAll(
          {
            filterAnd: `item_code:${selectedItemCode},is_active:true`,
            perpage: 10,
          },
          ({ data }) => {
            setState({ ...state, products: data.data });
          }
        );
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedItemCode]);

  useEffect(() => {
    if (selectedSupplierCode != "" && selectedSupplierCode.length >= 4) {
      const timeOut = setTimeout(() => {
        getSeupplier(selectedSupplierCode, { perpage: 10 }, ({ data }) => {
          setState({ ...state, suppliers: data.data });
        });
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedSupplierCode]);

  useEffect(() => {
    if (userInfo.access?.master_product?.can_update == false) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "You're not allowed to access that page!",
      });
      navigate("/");
    }
    $("#launch_date").datetimepicker({
      format: "YYYY-MM-DD",
    });
    $("#thickness").val(0);
  }, []);

  const [highlight_change, setHighlightChange] = useState(false);
  const [ecom_change, setEcomChange] = useState(false);
  const [usp_change, setUspChange] = useState(false);
  const [is_detail_saved, setIsDetailSaved] = useState(false);

  useEffect(() => {
    if (highlight_change == true) {
      setIsDraftSaved(false);
    }
  }, [highlight_change]);

  useEffect(() => {
    if (usp_change == true) {
      setIsDraftSaved(false);
    }
  }, [usp_change]);

  useEffect(() => {
    if (ecom_change == true) {
      setIsDraftSaved(false);
    }
  }, [ecom_change]);

  const propsDetailPage = {
    countryChange,
    state,
    setState,
    approval_status: state?.product?.incident_status_detail,
    next_step_nik_detail: state?.product?.next_step_nik_detail,
    setHighlightChange,
    setEcomChange,
    setUspChange,
    onSaveDraft,
    is_draft_saved,
    setDetailChange,
    setIsDetailSaved,
  };
  const propsProductImage = {
    files,
    filesDescs,
    register,
    errors,
    wrapStyle,
    onRemoveFile,
    onFileChange,
    onAddFileDesc,
    approval_status: state?.product?.incident_status_detail,
    next_step_nik_detail: state?.product?.next_step_nik_detail,
  };
  const propsProductVideo = {
    videoDescs,
    onFormVideo,
    onAddVideoDesc,
    onRemoveVideo,
    approval_status: state?.product?.incident_status_detail,
    next_step_nik_detail: state?.product?.next_step_nik_detail,
  };

  const onCloseModal = () => {
    if (
      fileSelected.media_types.length > 0 &&
      !fileSelected.media_types.toString().includes("usp") &&
      !fileSelected.media_types.toString().includes("highlight")
    ) {
      setTimeout(() => {
        $(modalId).modal("hide");
      }, 150);
    } else {
      toastError("Please complete image type isnot highlight or usp product!");
      return;
    }
  };

  const onSaveFeature = (reqF, totScore, productClass) => {
    if (totScore < reqF.length) {
      toastError("Please complete score feature type!");
      return;
    } else {
      const _feature_type = [...reqF];

      _feature_type.map((item, i) => {
        item.own = true;
      });

      setState((prev) => {
        return {
          ...prev,
          reqFeature: reqF,
          totScoreFeature: totScore,
          feature_type: _feature_type,
        };
      });

      setTimeout(() => {
        setValue("product_class", productClass);
        $(modalId10).modal("hide");
      }, 150);
    }
  };

  const onCloseModal2 = () => {
    setTimeout(() => {
      $(modalId2).modal("hide");
    }, 150);
  };

  const onCloseModal3 = () => {
    setTimeout(() => {
      $(modalId3).modal("hide");
    }, 150);
  };

  const onCloseModal4 = () => {
    setTimeout(() => {
      $(modalId10).modal("hide");
    }, 150);
  };

  const renderApprovalStatus = (status) => {
    if (status == "REJECTED") return "red";
    else if (status == "ONPROGRESS" || status == "ONREVISED") return "#66D3FA";
    else if (status == "COMPLETED") return "#8CC152";
    else return "blue";
  };

  const onAddFeatureModal = (a) => {
    setTimeout(() => {
      $(modalId10).modal("show");
    }, 150);
  };

  const onAddVideoDescModal = (type, position) => {
    const index =
      position == "media_types"
        ? videoDescs[videoSelected].media_types.indexOf(type)
        : videoDescs[videoSelected].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? videoDescs[videoSelected].media_types.splice(index, 1)
        : videoDescs[videoSelected].content_types.splice(index, 1);
    } else {
      position == "media_types"
        ? videoDescs[videoSelected].media_types.push(type)
        : videoDescs[videoSelected].content_types.push(type);
    }
    setState({ ...state, videoDescs });
  };

  const onFormVideoChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const [video_change, setVideoChange] = useState(false);

  const onSaveVideo = () => {
    const indexVideo = videoDescs.findIndex((e) => e.fileName == videoUrl);
    if (indexVideo > -1) {
      toastError("Video URL already exists!");
      return;
    }

    const indexLang = languages.findIndex((e) => e.language_code == videoLang);
    if (indexLang > -1) {
      videoDescs.push({
        filePath: Common.ytEmbedUrl,
        fileName: videoUrl,
        language_code: videoLang,
        language_name: JSON.parse(
          JSON.stringify(languages[indexLang].language_name)
        ),
        media_types: [],
        content_types: [],
      });
      setVideoChange(true);
      setState({ ...state, videoDescs, videoUrl: "", videoLang: "" });
      $(modalId2).modal("hide");
    } else {
      toastError("Failed video, please try againt!");
    }
  };

  const propsModalImageDesc = {
    modalId,
    onCloseModal,
    filesDescs,
    fileSelected,
    media_types,
    content_types,
    onAddFileDescModal,
    onDescChange,
  };
  const propsModalFormVideo = {
    modalId2,
    onCloseModal2,
    Common,
    videoUrl,
    onFormVideoChange,
    onSaveVideo,
    languages,
    videoLang,
    videoDescs,
  };
  const propsModalVideoDesc = {
    modalId3,
    onCloseModal3,
    videoDescs,
    videoSelected,
    video_types,
    content_types,
    onAddVideoDescModal,
  };
  const propsModalProductFeature = {
    sub_sub_category,
    modalId10,
    onCloseModal4,
    reqFeature,
    totScoreFeature,
    onAddFeatureModal,
    onSaveFeature,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Product Detail Form</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/product">Product</NavLink>
                </li>
                <li className="breadcrumb-item active">Product Detail Form</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <div>
                <h5
                  style={{
                    marginBottom: "1.1rem",
                    fontWeight: "200",
                    borderBottom: "1px solid black",
                    paddingBottom: "0.3rem",
                  }}
                >
                  SKU Info
                </h5>
                <div
                  className="d-flex"
                  style={{
                    flexWrap: "wrap",
                    columnGap: "20px",
                    justifyContent: "flex-start",
                    paddingLeft: "0.1rem",
                  }}
                >
                  <div className="form-group pmc-input-detail-container">
                    <label>Item Name</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.item_name}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>SKU No.</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={item_code}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>Model Code</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.model_code}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>Country</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={capitalizeFirstLetter(product?.country_name)}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "2rem" }}>
                <h5
                  style={{
                    marginBottom: "1.1rem",
                    fontWeight: "200",
                    borderBottom: "1px solid black",
                    paddingBottom: "0.3rem",
                  }}
                >
                  SKU Details
                </h5>
                <div
                  className="d-flex"
                  style={{
                    flexWrap: "wrap",
                    columnGap: "20px",
                    justifyContent: "flex-start",
                    paddingLeft: "0.1rem",
                  }}
                >
                  <div className="form-group pmc-input-detail-container">
                    <label>Category</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.category_name}
                    />
                  </div>

                  <div className="form-group pmc-input-detail-container">
                    <label>Subcategory</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.sub_category_name}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>Sub-subcategory</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.sub_sub_category_name}
                    />
                  </div>
                </div>
                <div
                  className="d-flex"
                  style={{
                    flexWrap: "wrap",
                    columnGap: "20px",
                    justifyContent: "flex-start",
                    paddingLeft: "0.1rem",
                  }}
                >
                  <div className="form-group pmc-input-detail-container">
                    <label>Brand Name</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.brand_name}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>Series Name</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.series_name}
                    />
                  </div>
                  <div className="form-group pmc-input-detail-container">
                    <label>Segment Name</label>
                    <input
                      readOnly={true}
                      className="form-control pmc-input-detail-special"
                      value={product?.segment_name}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />
                <form
                  className="form-create-product-detail"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <ProductImage {...propsProductImage} />
                      </div>
                      <div className="col-md-12">
                        <ProductVideo {...propsProductVideo} />
                      </div>
                    </div>

                    <div className="dropdown-divider" />
                    <ProductDetailPage {...propsDetailPage} />
                  </div>
                  <div className="card-footer">
                    <div
                      className="d-flex"
                      style={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex"
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            Approval Status:
                            <span
                              style={{
                                color: renderApprovalStatus(
                                  state.product?.incident_status_detail
                                ),
                              }}
                            >
                              &nbsp;
                              <b>
                                {state.product?.incident_status_detail &&
                                  state.product?.incident_status_detail != "null"
                                  ? state.product?.incident_status_detail
                                  : "NOT SUBMITTED"}
                              </b>
                              <span style={{ color: "grey" }}>{state.mode ?? ''}</span>
                            </span>
                          </div>
                          {state?.product?.next_step_nik_detail ==
                            userInfo.nik && (
                              <div
                                className="d-flex"
                                style={{
                                  columnGap: "15px",
                                  padding: "0 1.4rem",
                                }}
                              >
                                {state?.product?.incident_status_detail ==
                                  "ONPROGRESS" && (
                                    <button
                                      disabled={processing}
                                      className="btn btn-success"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        let code = APPROVE;
                                        onApprovalAction(code);
                                      }}
                                    >
                                      <i className="fa fa-check" /> Approve
                                    </button>
                                  )}
                                <button
                                  title={
                                    state.product.incident_status_detail ==
                                    "ONREVISED" &&
                                    state.product.next_step_nik_detail ==
                                    userInfo.nik &&
                                    "You have to save draft first"
                                  }
                                  disabled={
                                    processing ||
                                    (is_draft_saved == false &&
                                      state.product.incident_status_detail ==
                                      "ONREVISED" &&
                                      state.product.next_step_nik_detail ==
                                      userInfo.nik)
                                  }
                                  className="btn btn-primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    let code = undefined;
                                    if (
                                      state?.product?.incident_status_detail ==
                                      "ONPROGRESS"
                                    )
                                      code = REVISE;
                                    else if (
                                      state?.product?.incident_status_detail ==
                                      "ONREVISED"
                                    )
                                      code = APPROVE;
                                    onApprovalAction(code);
                                  }}
                                >
                                  <i className="fa fa-edit" /> Revise
                                </button>
                                {state?.product?.incident_status_detail ==
                                  "ONPROGRESS" && (
                                    <button
                                      disabled={processing}
                                      className="btn btn-danger"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        let code = REJECT;
                                        onApprovalAction(code);
                                      }}
                                    >
                                      <i className="fa fa-times" /> Reject
                                    </button>
                                  )}
                              </div>
                            )}
                        </div>
                      </div>
                      <div>
                        <div
                          className="d-flex"
                          style={{ justifyContent: "flex-end" }}
                        >
                          {/* <button
                            style={{ padding: "0.4rem 0.9rem" }}
                            disabled={
                              state?.product?.incident_status_detail == "ONPROGRESS" ||
                              (detail_change == true && is_detail_saved == false) ||
                              (state?.product?.incident_status_detail == "ONREVISED" &&
                                state.product.next_step_nik_detail != userInfo.nik)
                            }
                            type="button"
                            className="btn btn-dark mr-3"
                            onClick={onSaveDraft}
                          >
                            <i className="fa fa-save"></i> Draft
                          </button> */}
                          <button
                            type="button"
                            className="btn btn-secondary mr-3"
                            style={{ width: 150, fontSize: "0.95rem" }}
                            onClick={() => navigate("/product")}
                          >
                            <i className="fa fa-reply" /> Products List
                          </button>
                          {userInfo.access?.approvals?.can_view == true && (
                            <button
                              type="button"
                              className="btn btn-warning mr-3"
                              style={{ width: 150, fontSize: "0.95rem" }}
                              onClick={() => navigate("/approvals")}
                            >
                              <i className="fa fa-reply" /> Approvals List
                            </button>
                          )}
                          <button
                            type="submit"
                            className="btn btn-success"
                            style={{ width: 150, fontSize: "0.95rem" }}
                            disabled={
                              !userInfo.access.master_product?.can_create ||
                              state?.product?.incident_status_detail ==
                              "ONPROGRESS" ||
                              state?.product?.incident_status_detail ==
                              "ONREVISED" ||
                              is_draft_saved == false
                            }
                          >
                            <i className="fa fa-save" /> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModalImageDesc {...propsModalImageDesc} />
      <ModalFormVideo {...propsModalFormVideo} />
      <ModalVideoDesc {...propsModalVideoDesc} />
      <ModalFormFeature {...propsModalProductFeature} />

      {/*<ModalImageDesc {...propsModalImageDesc} />
      <ModalFormVideo {...propsModalFormVideo} />
      <ModalVideoDesc {...propsModalVideoDesc} />
                          <ModalFormFeature {...propsModalProductFeature} />*/}
    </div>
  );
};

export default ProductDetailFormPage;
